import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "gridTemplate", "gridTemplateColumns", "gridTemplateRows"];
import { Layout } from './Layout';
import styled from 'styled-components';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLayoutGrid = styled(Layout).withConfig({
  displayName: "LayoutGrid__StyledLayoutGrid",
  componentId: "sc-1m1wiby-0"
})(["", " ", " ", ""], ({
  $gridTemplateColumns
}) => $gridTemplateColumns && `grid-template-columns: ${$gridTemplateColumns};`, ({
  $gridTemplateRows
}) => $gridTemplateRows && `grid-template-rows: ${$gridTemplateRows};`, ({
  $gridTemplate
}) => $gridTemplate && `grid-template: ${$gridTemplate};`);
export const LayoutGrid = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as,
      children,
      gridTemplate,
      gridTemplateColumns,
      gridTemplateRows
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledLayoutGrid, Object.assign({}, rest, {
    $gridTemplate: gridTemplate,
    $gridTemplateColumns: gridTemplateColumns,
    $gridTemplateRows: gridTemplateRows,
    display: "grid",
    forwardedAs: as,
    ref: ref,
    children: children
  }));
});